const DAYS = [[1, "Mon"], [2, "Tue"], [3, "Wed"], [4, "Thu"], [5, "Fri"], [6, "Sat"], [7, "Sun"]];

/** Mon–Sun toggle chips. value: number[] (ISO weekdays) or null (= inherit, when allowed). */
export const OpenDaysPicker = ({ value, onChange, inheritLabel, testid = "open-days" }) => {
  const inherit = value === null || value === undefined;
  const days = inherit ? [] : value;
  const toggle = (d) => {
    const next = days.includes(d) ? days.filter((x) => x !== d) : [...days, d].sort();
    onChange(next);
  };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      {inheritLabel && (
        <button
          type="button"
          onClick={() => onChange(inherit ? [1, 2, 3, 4, 5, 6, 7] : null)}
          className={`rounded-full border px-2.5 py-1 text-xs transition-colors ${inherit ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 hover:bg-slate-50"}`}
          data-testid={`${testid}-inherit`}
        >
          {inheritLabel}
        </button>
      )}
      {DAYS.map(([d, label]) => {
        const on = inherit ? false : days.includes(d);
        return (
          <button
            key={d}
            type="button"
            disabled={inherit}
            onClick={() => toggle(d)}
            className={`w-11 rounded-md border py-1 text-xs font-medium transition-colors disabled:opacity-40 ${on ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-slate-500 hover:bg-slate-50"}`}
            data-testid={`${testid}-${d}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
